
import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';



export default class SlideUp extends React.Component {


    constructor(props){
        super(props);
        this.state = {
           bottom: -100,
           target: 0,
        }
      }
      


    componentDidMount() {

        this.interval = setTimeout(() => {

            this.interval = setInterval(() => {
            
                this.setState({bottom: (this.state.bottom * 4 + this.state.target) / 5})

            }, 1000/40);

        }, 1200);



      }

    componentWillUnmount() {
        clearInterval(this.interval);
      }

    render() {


    const handleClick = () => {

        this.setState({target: -100})

        

        setTimeout(() => {

            this.props.setResult(true)

        }, 200)

    }


    return (


        <div class="slideup" style={{bottom: this.state.bottom+"vh"}}>
            <p class="intro">
            <h1>Terms & Conditions Apply</h1>
            </p>

            <p class="intro">A mini-game about pop ups, and the deviousness of websites and apps</p>

            <p class="intro">EVIL CORP wants <strong>your data</strong>.
            It will use every trick in the book (and a few more, <strong>just for fun</strong>).</p>

            <p class="intro">
                
                Your mission is as follows: <br></br>

                <img class="tick" src="../images/tick.png"></img>Do <strong>not</strong> accept any terms & conditions <br></br>

                <img class="tick" src="../images/tick.png"></img>Say <strong>no</strong> to all notifications <br></br>

                <img class="tick" src="../images/tick.png"></img>Always <strong>opt out</strong> of cookies.
                
            </p>


            <p class="intro">


                EVIL CORP want you to sign up for <strong>everything</strong>.<br></br>

                You must never accept <strong>anything</strong><br></br>

                Answer all 29 questions to find out how well you did. <br></br> <br></br>

                <Button value="1" onMouseDown={handleClick} className="m-1 start-button" variant="secondary" size="lg">Play Now</Button>


        
                            
            </p>


            



        </div>

        )

    }

}
